<template>
  <div>
    <table class="table" :class="tableClass">
      <thead>
        <slot name="columns">
          <th v-for="column in columns" :key="column">{{ column }}</th>
        </slot>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td>
            <img v-if="item.artwork_path.includes('184.169.148.201:3220')" class="gallery thumbnail zoom" style="width: 35%; height: 35%" :src="item.artwork_path.replace('184.169.148.201:3220', 'subprint.printverse.com')" />
            <img v-else class="gallery thumbnail zoom" style="width: 35%; height: 35%" :src="item.artwork_path" />
          </td>
          <td>
            <span>{{ item.reference_id }}</span>
          </td>
          <td>
            <span>{{ item.product_name }}</span>
          </td>
          <td>
            <span>{{ item.skus }}</span>
          </td>
          <td>
            <span>{{ item.qty }}</span>
          </td>
          <td>
            <span>{{ item.total_quantity }}</span>
          </td>
          <td>
            <span>{{ item.totalQty }}</span>
          </td>
          <td>
            <span>{{ item.currQty }}</span>
          </td>
          <td>
            <span>{{ item.bins }}</span>
          </td>
          <td>
            <span>{{ item.shipReady }}</span>
          </td>
          <td>
            <b-button id="show-btn" @click="showModal(item.artworks)">Order</b-button>
          </td>
          <!-- <slot :row="item">
          <td v-for="(column, index) in columns" :key="index">
            {{ itemValue(item, column) }}
          </td>
        </slot> -->
        </tr>
      </tbody>
    </table>
    <b-modal ref="my-modal" size="lg" hide-footer title="Entire Order">
      <div class="d-block text-center">
        <div id="display" class="row">
          <div class="col-sm-6 col-md-6 col-lg-6" style="margin-top: 10px;" v-for="(pair, index) in art" :key="index">
            <label>Item ID: {{pair.barcode_id}}</label>
            <img class="thumbnail zoom" :src="pair.artwork_path" style="width: 95%; height: 95%; border: .5px solid #555;">
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import QuantityModal from "@/components/QuantityModal.vue";
export default {
  name: "shelved-table",
  data() {
    return {
      isModalVisible: false,
      quantity: "",
      art: null,
    };
  },
  components: {
    QuantityModal,
  },
  props: {
    columns: Array,
    data: Array,
    type: {
      type: String, // striped | hover
      default: "striped",
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    },
  },
  methods: {
    showModal(artworks) {
      //console.log("item: " + JSON.stringify(artworks));
      //this.reprintOrders.push(item);
      
      let exampleBarcode = artworks[0]["barcode_id"];
      if (exampleBarcode.includes('S')) {
        //console.log('Entering Switch');
        for (let i=0; i < artworks.length; i++) {
          let currObj = artworks[i];
          let path = currObj["artwork_path"];
          //console.log(path);
          //console.log(path.includes('184.169.148.201:3220'));
          if (path.includes('184.169.148.201:3220')) {
            path = path.replace('184.169.148.201:3220', 'subprint.printverse.com');
          }
          artworks[i]["artwork_path"] = path;
        }
      }
      //console.log("item second: " + JSON.stringify(artworks));
      this.art = artworks;
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    Undo: function() {
      console.log("Not Implented Yet");
      return;
    },

    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    },
  },
};
</script>
<style>
  .gallery{    
    margin-left: 5vw;     
    margin-right:5vw;  
  }    

  .zoom {      
    -webkit-transition: all 0.35s ease-in-out;    
    -moz-transition: all 0.35s ease-in-out;    
    transition: all 0.35s ease-in-out;     
    cursor: -webkit-zoom-in;      
    cursor: -moz-zoom-in;      
    cursor: zoom-in;  
  }     

  .zoom:hover,  
  .zoom:active,   
  .zoom:focus {
    /**adjust scale to desired size, add browser prefixes**/
    -ms-transform: scale(2.0);    
    -moz-transform: scale(2.0);  
    -webkit-transform: scale(2.0);  
    -o-transform: scale(2.0);  
    transform: scale(2.0);    
    position:relative;      
    z-index:100;  
  }

  /**To keep upscaled images visible on mobile, increase left & right margins a bit**/  
  @media only screen and (max-width: 768px) {   
    .gallery {      
      margin-left: 15vw;       
      margin-right: 15vw;
    }

    /**TIP: Easy escape for touch screens,give gallery's parent container a cursor: pointer.**/
    .DivName {
      cursor: pointer
    }
  }
</style>
